import NavbarContentUserProfileButton from "./NavbarContentUserProfileButton";

export default function NavbarContent() {
  return (
    <div>
      <NavbarContentUserProfileButton />
    </div>
  );
}
